import React from 'react';
import { cn } from '../../lib/utils';

/**
 * Chip selecionável dentro de modais Office (telas, duração, etc.).
 * Usa aria-pressed + .office-choice-btn para o CSS não apagar o estado activo.
 */
export default function OfficeChoiceButton({
  active = false,
  disabled = false,
  className,
  children,
  ...props
}) {
  return (
    <button
      type="button"
      aria-pressed={active}
      disabled={disabled}
      className={cn(
        'office-choice-btn h-11 rounded-lg border font-semibold tabular-nums transition-colors duration-150',
        active
          ? 'office-choice-btn--active border-primary bg-primary text-primary-foreground'
          : 'border-border bg-background text-foreground hover:bg-muted',
        disabled && 'cursor-not-allowed opacity-50',
        className,
      )}
      {...props}
    >
      {children}
    </button>
  );
}
